import React from "react";
import styleFooter from "./Footer.module.css";
import Logo from  '../../assets/logo.png'

function Footer() {
  return (
    <footer className={styleFooter["footer-container"]}>
      <div className={`${styleFooter["footer-top"]} footer-top`}>
        <div className={`${styleFooter["footer-brand"]} footer-brand`}>
          <img
            src={Logo}
            alt=""
            className={`${styleFooter["footer-logo"]} footer-logo`}
          />
          <p>
            BajajCapital is India’s premier investment services group engaged
            inter-alia in the distribution of mutual funds, insurance, fixed
            deposits, bonds, loans etc.
          </p>
        </div>

        {/* <div className={`${styleFooter["footer-links"]} footer-links`}>
          <div>
            <h4>Offering</h4>
            <ul>
              <li>Mutual Funds</li>
              <li>Insurance</li>
              <li>Bonds</li>
              <li>National Pension Scheme</li>
              <li>Fixed Deposits</li>
              <li>Home Loan</li>
              <li>Exclusively for Women</li>
              <li>AMC for Investments</li>
              <li>Invest in Real Estate</li>
            </ul>
          </div>

          <div>
            <h4>Calculators</h4>
            <ul>
              <li>Systematic Investment Planner</li>
              <li>Home Loan EMI</li>
              <li>Pension</li>
              <li>Child Marriage Planner</li>
              <li>Maturity Amount</li>
              <li>Gratuity</li>
              <li>Tax Saving</li>
              <li>Retirement Planning</li>
              <li>Crorepati</li>
            </ul>
          </div>

          <div className="resc">
            <h4>Resources</h4>
            <ul>
              <li>About Us</li> 
              <li>New Brand Identity</li>
              <li>Branch Locator</li>
             <li>Careers</li>
              <li>Help Centre</li>
              <li>
                    <Link to="/PrivacyPolicy">Privacy Policy</Link>
                  </li>
              <li>Publications</li>
              <li>CEO Bajaj Capital Insurance</li>
            </ul>
          </div>
        </div> */}

        <div className={`${styleFooter["footer-contact"]} footer-contact`}>
          <h4>Contact</h4>
          <ul>
            <li>📞 7678123123</li>
            <li>📞 1800-313-123123</li>
            <li>Mon - Sat (10 AM - 6 PM)</li>
          </ul>
          <p>
            In case of any queries, feel free to call or write to us. We will be
            very happy to assist you.
          </p>
          <p className="d-none">contactus@bajajcapital.com</p>
          <div className={`${styleFooter["social-icons"]} social-icons d-none`}>
            <ul>
              <li>
                <a>
                  <img src="/assets/icons/facebook-icon.png" alt="facebook icon" />
                </a>
              </li>
              <li>
                <a>
                  <img src="/assets/icons/instagram.png" alt="facebook icon" />
                </a>
              </li>
              <li>
                <a>
                  <img src="/assets/icons/linkden-icon.png" alt="facebook icon" />
                </a>
              </li>
              <li>
                <a>
                  <img src="/assets/icons/x-logo.png" alt="facebook icon" />
                </a>
              </li>
              <li>
                <a>
                  <img src="/assets/icons/youtube-icon.png" alt="facebook icon" />
                </a>
              </li>
            </ul>
            {/* <FacebookIcon />
            <TwitterIcon />
            <LinkedInIcon />
            <InstagramIcon />
            <YouTubeIcon /> */}
          </div>
        </div>
      </div>
      <div className={`${styleFooter["footer-bottom"]} footer-bottom`}>
        {/* <div className="container">
          <div className="row">
            <div className="col-12 text-center pb-3 ps-md-0 col-md-5 text-md-start   pb-md-0">
              <p className={`${styleFooter["copyright"]} copyright`}>
                Copyright &copy; 2020 Pre Retirement
              </p>
            </div> */}
              <p className={`${styleFooter["copyright"]} copyright`}>
                Copyright &copy; 2020 Pre Retirement
              </p>
            {/* <div className="col-12 text-center col-md-7 text-md-end">
              <ul className={`${styleFooter["bottom-pane-links"]} bottom-pane-links`}>
                <li><a href="/Aboutus">About Us</a></li>
                <li><a href="/PrivacyPolicy#privacy-policy">Privacy Policy</a></li>
                <li><a href="/PrivacyPolicy#terms-conditions">Terms and Conditions</a></li>
                <li><a href="/PrivacyPolicy#legal-disclaimer">Legal Disclaimer</a></li>
              </ul>
            </div> */}
          {/* </div>
        </div> */}
      </div>
      {/* <div className="footer-bottom">
        <p align-items-right>
          Copyright © 2020 Bajaj Capital Limited | <a href="#legal">Legal Disclaimer</a> | <a href="#privacy">Privacy Policy</a> | <a href="#terms">Terms and Conditions</a>
        </p>
      </div> */}
    </footer>
  );
}

export default Footer;
